import React, { useState, useEffect ,useRef} from "react";
import { Modal, Button, Form, Card, Row, Col , Table,Dropdown} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PurchaseOrderMaster = () => {
  const tableHeaders = [
    "#",
    "PO Number",
    "PO Date",
    "Expected Delivery",
    "Supplier",
    "Payment Status",
    "Order Status",
  ];
  const navigate = useNavigate();
  const poSummaryRef = useRef(null);
  const [poData, setPoData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [supplierData, setSupplierData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [errors, setErrors] = useState({});
  const [selectedPo, setSelectedPo] = useState(null);
  const [showPoSummary, setShowPoSummary] = useState(false);
  const [productData, setProductData] = useState([]);
  const [items, setItems] = useState([]);
  const [details, setDetails] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [discount, setDiscount] = useState(0);
  const [showMailCard, setShowMailCard] = useState(false);
  const [showAddEditForm, setShowAddEditForm] = useState(false);
  const [toEmail, setToEmail] = useState("");
  const [ccEmail, setCcEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const createdByName = localStorage.getItem("user_name") || "";
  const [selectedRow, setSelectedRow] = useState(null);
  const [showPaymentCard, setShowPaymentCard] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showPDFView, setShowPDFView] = useState(false);
  const [showStage, setShowStage] = useState("empty");
  const [formData, setFormData] = useState({
    id: null,
    business_id: 1,
    city_id: localStorage.getItem("city_id") || "",
    warehouse_id: 1,
    po_number: "",
    po_date: "",
    expected_delivery_date: "",
    supplier_id: "",
    total_amount: "",
    payment_status: 1,
    order_status: 1,
    remarks: "",
    order_type: "",
    qty: "",
  });

  useEffect(() => {
    loadInitialData();
    fetchSupplierData();
    fetchProductData();
  }, []);

  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];
      setProductData(allProducts);
    } catch (err) {
      toast.error("Failed to fetch product data");
    }
  };

  const [profileData, setProfileData] = useState(null);
  const userid = localStorage.getItem('user_id');
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [localStatus, setLocalStatus] = useState(null);

  const fetchProfile = async () => {
    try {
      const res = await axios.post("https://test-api.veezzo.in/login/warehouse-login", {
        email: email,
        password: password,
      });

      const user = res.data.user;
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("warehouse_email", user.email_id);
      localStorage.setItem("user_name", user.name);
      localStorage.setItem("mobile", user.contact_no1);
      localStorage.setItem("warehouse_id", user.warehouse_id);
      localStorage.setItem("user_id", user.id);
      localStorage.setItem("role", user.role);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedPo) {
      setLocalStatus(selectedPo.order_status);
    }
  }, [selectedPo]);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchPoData();
    } catch (err) {
      toast.error("Error loading initial data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchPoData = async () => {
    const warehouse_id = localStorage.getItem("warehouse_id");
    try {
      const res = await axios.get(`${var_api}sa_veemart_po/get-warehouse/${warehouse_id}`);
      let data = Array.isArray(res.data) ? res.data : res.data.data || [];
      data = data.sort((a, b) => b.id - a.id);
      setPoData(data);
    } catch (err) {
      toast.error("Failed to fetch PO data");
    }
  };

  const fetchSupplierData = async () => {
    try {
      const res = await axios.get(`${var_api}ci_veemart_supplier_master/get-warehouse-active/${localStorage.getItem("warehouse_id")}`);
      const suppliers = Array.isArray(res.data) ? res.data : res.data.data || [];
      setSupplierData(suppliers);
    } catch (err) {
      console.error("Failed to fetch suppliers:", err);
      toast.error("Failed to fetch supplier data");
    }
  };

  const getSupplierName = (id) => {
    const supplier = supplierData.find((s) => s.id === id);
    return supplier ? supplier.supplier_name : "-";
  };

  // ✅ CHANGE 1: handleAddRow - Default qty_count changed to 0.000
  const handleAddRow = () => {
    setItems([
      ...items,
      { 
        product_id: "", 
        product_name: "", 
        veemart_product_code: "", 
        qty_count: 0.000,  // Changed from 1
        unit_price: 0 
      },
    ]);
  };

  // ✅ CHANGE 2: handleItemChange - Use parseFloat for qty and price
  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    
    if (field === "qty_count" || field === "unit_price") {
      updated[index][field] = parseFloat(value) || 0;  // Changed to parseFloat
    } else {
      updated[index][field] = value;
    }

    // If they choose product dropdown
    if (field === "product_id") {
      const p = productData.find((x) => x.id == value);
      updated[index].product_name = p?.product_name || "";
      updated[index].unit_price = parseFloat(p?.unit_price) || 0;  // Changed to parseFloat
    }

    setItems(updated);
  };

  const handleRemoveRow = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  // ✅ CHANGE 3: handleAddToSelected - Default qty_count changed to 0.000
 const handleAddToSelected = (item) => {
  setSelectedProducts((prev) => {
    // ✅ If already selected → REMOVE
    if (prev[item.id]) {
      const updated = { ...prev };
      delete updated[item.id];
      return updated;
    }

    // ✅ Else → ADD
    return {
      ...prev,
      [item.id]: {
        product_id: item.id,
        product_name: item.product_name,
        veemart_product_code: item.veemart_product_code,
        qty_count: 0.000,
        unit_price: parseFloat(item.unit_price) || 0,
      },
    };
  });
};


  // ✅ CHANGE 4: handleQtyChange - Use parseFloat
  const handleQtyChange = (id, qty) => {
    setSelectedProducts((prev) => ({
      ...prev,
      [id]: { ...prev[id], qty_count: parseFloat(qty) || 0 },  // Changed to parseFloat
    }));
  };

  const handleConfirmBulkAdd = () => {
    const newItems = Object.values(selectedProducts).filter(Boolean);
    setItems([...items, ...newItems]);
    setSelectedProducts({});
    setShowBulkModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedData = { ...prev, [name]: value };

      if (
        updatedData.po_date &&
        updatedData.expected_delivery_date &&
        updatedData.expected_delivery_date < updatedData.po_date
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          expected_delivery_date:
            "Expected delivery date cannot be earlier than PO date",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          expected_delivery_date: "",
        }));
      }

      return updatedData;
    });

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const generatePoNumber = async (warehouse_id) => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_po/generate-po-number/${warehouse_id}`);
      if (res.data && res.data.po_number) {
        setFormData((prev) => ({ ...prev, po_number: res.data.po_number }));
      } else {
        toast.warning("PO number not generated");
      }
    } catch (err) {
      console.error("Error generating PO number:", err);
      toast.error("Failed to generate PO number");
    }
  };

  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);

  // ✅ CHANGE 5: Subtotal calculation - Use parseFloat
  useEffect(() => {
    const newSubtotal = items.reduce((sum, item) => {
      const qty = parseFloat(item.qty_count) || 0;  // Changed to parseFloat
      const price = parseFloat(item.unit_price) || 0;  // Changed to parseFloat
      return sum + qty * price;
    }, 0);

    setSubTotal(newSubtotal);
  }, [items]);

  // ✅ CHANGE 6: Total calculation - Use parseFloat
  useEffect(() => {
    const totalValue = subTotal - (parseFloat(discount) || 0);  // Changed to parseFloat
    setTotal(totalValue);
  }, [subTotal, discount]);

  const handleAddClick = async () => {
    const warehouseId = 1;
    const today = new Date().toISOString().split("T")[0];

    setFormData({
      id: null,
      business_id: 1,
      city_id: localStorage.getItem("city_id") || "",
      warehouse_id: warehouseId,
      po_number: "",
      po_date: today,
      expected_delivery_date: "",
      supplier_id: "",
      total_amount: "",
      payment_status: 1,
      order_status: 1,
      remarks: "",
      order_type: "",
      qty: "",
    });

    setErrors({});
    setIsEditMode(false);
    setShowModal(true);
    setShowAddEditForm(true);
    setShowPoSummary(false);
    setShowMailCard(false);

    await generatePoNumber(warehouseId);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setShowModal(true);
    setShowAddEditForm(true);
    setShowPoSummary(false);
    setShowMailCard(false);
  };

  // ✅ CHANGE 7: handleSubmit - All calculations use parseFloat and toFixed
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.po_date) newErrors.po_date = "PO Date is required";
    if (!formData.supplier_id) newErrors.supplier_id = "Supplier is required";
    if (!items.length) newErrors.items = "At least one item is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.warning("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      const formattedItems = items.map((item) => ({
        product_id: item.product_id,
        product_name: item.product_name,
        qty: parseFloat(item.qty_count).toFixed(3),  // Changed: parseFloat + toFixed(3)
        unit_price: parseFloat(item.unit_price).toFixed(2),  // Changed: parseFloat + toFixed(2)
        discount: parseFloat(discount).toFixed(2) || "0.00",  // Changed: parseFloat + toFixed(2)
        sub_total: (parseFloat(item.qty_count) * parseFloat(item.unit_price)).toFixed(2),  // Changed
      }));

      const totalQty = items.reduce(
        (sum, item) => sum + (parseFloat(item.qty_count) || 0),  // Changed to parseFloat
        0
      );

      const payload = {
        ...formData,
        qty: parseFloat(totalQty).toFixed(3),  // Changed: toFixed(3)
        total_amount: parseFloat(total).toFixed(2),  // Changed: toFixed(2)
        details: formattedItems,
      };

      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(
          `${var_api}sa_veemart_po/update/${formData.id}`,
          payload
        );
      } else {
        res = await axios.post(`${var_api}sa_veemart_po/post`, payload);
      }

      toast.success(res?.data?.message || "PO saved successfully!");
      setShowModal(false);
      showMainTable();
      fetchPoData();
    } catch (err) {
      console.error("Error saving PO:", err);
      toast.error("Failed to save PO");
    } finally {
      setLoading(false);
    }
  };

  const handleDraftClick = async (po) => {
    setSelectedPo(po);
    localStorage.setItem("sa_veemart_po_id", po.id);

    try {
      const res = await axios.get(
        `${var_api}sa_veemart_po_details/getByPoId/${po.id}`
      );

      const poItems = Array.isArray(res.data) ? res.data : [];
      setPoData(poItems);
      setShowPoSummary(true);
    } catch (err) {
      toast.error("Failed to fetch PO details");
    }
  };

  const getProductName = (id) => {
    const p = productData.find((item) => item.id === id);
    return p ? p.product_name : "-";
  };

  const handleSendMailClick = () => {
    setShowAddEditForm(false);
    setShowPoSummary(false);
    setShowMailCard(true);
  };

  const handlePaymentStatusClick = async (row) => {
    setSelectedRow(row);
    const po_id = row.id;
    localStorage.setItem("sa_veemart_po_id", po_id);

    try {
      const res = await axios.get(
        `${var_api}sa_veemart_po_details/getByPoId/${po_id}`
      );

      const poItems = Array.isArray(res.data) ? res.data : [];
      setPoData(poItems);
      setShowPaymentCard(true);
      setShowAddEditForm(false);
      setShowPoSummary(false);
      setShowMailCard(false);
    } catch (err) {
      toast.error("Failed to fetch PO details");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const showMainTable = () => {
    setShowAddEditForm(false);
    setShowPoSummary(false);
    setShowMailCard(false);
    setShowPaymentCard(false);
    setSelectedPo(null);
    setSelectedRow(null);
    setPoData([]);
    setItems([]);
    setBody("");
    setToEmail("");
    setCcEmail("");
    setSubject("");
    setLocalStatus(null);
  };

  const handleReceiveClick = async () => {
    try {
      localStorage.setItem("sa_veemart_po_id", selectedPo.id);
      localStorage.setItem("sa_veemart_po_number", selectedPo.po_number);
      navigate("/grn");
    } catch (err) {
      toast.error("Failed to load GRN");
    }
  };

  const handleDownloadPDF = async () => {
    if (!poSummaryRef.current) {
      toast.error("Right section not found!");
      return;
    }

    const input = poSummaryRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("PurchaseOrder.pdf");
  };

  const handlePrint = () => {
    if (!poSummaryRef.current) {
      toast.error("Right section not found!");
      return;
    }

    const printContent = poSummaryRef.current.innerHTML;
    const win = window.open("", "", "height=700,width=900");
    win.document.write("<html><head><title>Print</title></head><body>");
    win.document.write(printContent);
    win.document.write("</body></html>");
    win.document.close();
    win.print();
  };

  const handleConvertToPay = async () => {
    try {
      await axios.put(`${var_api}sa_veemart_po/update-payment-status`, {
        id: selectedRow.id,
        payment_status: 2,
      });

      toast.success("Payment Updated");
      setSelectedRow({ ...selectedRow, payment_status: 2 });
      fetchPoData();
    } catch (err) {
      toast.error("Failed to update payment status");
    }
  };

  const filteredData = poData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getPaymentStatusLabel = (val) => {
    if (val === 1 || val === "1") return "Pending";
    if (val === 2 || val === "2") return "Paid";
    if (val === 3 || val === "3") return "Partial";
    return "N/A";
  };

  const getOrderStatusLabel = (val) => {
    if (val === 1 || val === "1") return "Draft";
    if (val === 2 || val === "2") return "Issued";
    return "N/A";
  };

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              {!showAddEditForm && !showPoSummary && !showMailCard && !showPaymentCard && (
                <>
                  <div className="d-flex justify-content-end mb-3 gap-2">
                    <input
                      type="text"
                      className="form-control w-auto"
                      placeholder="Search PO..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <Button variant="secondary" onClick={handleAddClick}>
                      Add
                    </Button>
                  </div>

                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>{tableHeaders.map((h, i) => <th key={i}>{h}</th>)}</tr>
                      </thead>
                      <tbody>
                        {paginatedData.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center text-muted py-3">
                              No data found
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((item, idx) => (
                            <tr key={item.id}>
                              <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                              <td>{item.po_number}</td>
                              <td>{formatDate(item.po_date)}</td>
                              <td>{formatDate(item.expected_delivery_date)}</td>
                              <td>{getSupplierName(item.supplier_id)}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    item.payment_status === 2 ? "bg-success" : "bg-info"
                                  }`}
                                  style={{ cursor: "pointer", fontSize: "12px" }}
                                  onClick={() => handlePaymentStatusClick(item)}
                                >
                                  {getPaymentStatusLabel(item.payment_status)}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    item.order_status === 2 ? "bg-secondary" : "bg-warning"
                                  }`}
                                  style={{ cursor: "pointer", fontSize: "12px" }}
                                  onClick={() => handleDraftClick(item)}
                                >
                                  {getOrderStatusLabel(item.order_status)}
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-end mt-3">
                      {[...Array(totalPages)].map((_, i) => (
                        <Button
                          key={i}
                          variant={currentPage === i + 1 ? "primary" : "light"}
                          onClick={() => setCurrentPage(i + 1)}
                          className="me-1"
                        >
                          {i + 1}
                        </Button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {showPoSummary && selectedPo && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "100vh", background: "linear-gradient(to bottom right, #f8f9fa, #e9ecef)", padding: "20px" }}
                >
                  <Card className="shadow-lg border-0" style={{ width: "100%", maxWidth: "1400px", borderRadius: "16px", overflow: "hidden" }}>
                    <Card.Body className="p-0">
                      <Row className="g-0">
                        <Col md={3} style={{ backgroundColor: "#f8f9fa", borderRight: "1px solid #dee2e6" }}>
                          <div className="p-4">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                              <h6 className="mb-0 fw-bold">All Purchase Orders</h6>
                            </div>

                            <Card className="mb-2" style={{ backgroundColor: "#fff", border: "2px solid #007bff", borderRadius: "8px" }}>
                              <Card.Body className="p-3">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <div>
                                    <h6 className="mb-1 fw-bold">{selectedPo.po_number}</h6>
                                    <p>
                                      <strong>PO Date:</strong>{" "}
                                      {selectedPo.po_date
                                        ? new Date(selectedPo.po_date).toLocaleDateString("en-GB")
                                        : "-"}
                                    </p>
                                  </div>
                                  <div className="text-end">
                                    <h6 className="mb-0">₹{parseFloat(selectedPo.total_amount).toFixed(2)}</h6>
                                  </div>
                                </div>
                                <small className="text-muted">{getSupplierName(selectedPo.supplier_id)}</small>
                              </Card.Body>
                            </Card>
                          </div>
                        </Col>

                        <Col md={9}>
                          <div className="p-4">
                            <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                              <div className="d-flex align-items-center gap-3">
                                <Button 
                                  variant="outline-secondary" 
                                  size="sm" 
                                  onClick={() => window.location.reload()}
                                >
                                  <i className="fas fa-arrow-left me-2"></i>Back
                                </Button>
                                <h2 className="mb-0 fw-bold">{selectedPo.po_number}</h2>
                              </div>
                              <div className="d-flex gap-2">
                                {localStatus === 1 ? (
                                  <Button
                                    variant="primary"
                                    onClick={async () => {
                                      try {
                                        await axios.put(`${var_api}sa_veemart_po/update-order-status`, {
                                          id: selectedPo.id,
                                          order_status: 2,
                                        });
                                        toast.success("Purchase Order marked as Issued!");
                                        setLocalStatus(2);
                                      } catch (err) {
                                        toast.error("Failed to update status");
                                      }
                                    }}
                                  >
                                    Mark as Issued
                                  </Button>
                                ) : (
                                  <Button
                                    variant="success"
                                    onClick={handleReceiveClick}
                                  >
                                    Go to Received
                                  </Button>
                                )}

                                <Button variant="outline-primary" size="sm" onClick={handleSendMailClick}>
                                  <i className="fas fa-envelope me-2"></i>Send Mail
                                </Button>

                                <Dropdown>
                                  <Dropdown.Toggle variant="outline-secondary" size="sm">
                                    <i className="fas fa-file-pdf me-2"></i>PDF / Print
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleDownloadPDF}>Download PDF</Dropdown.Item>
                                    <Dropdown.Item onClick={handlePrint}>Print</Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>

                            <div className="alert d-flex justify-content-between align-items-center mb-4" style={{ backgroundColor: "#e7f3ff", border: "1px solid #b3d9ff", borderRadius: "8px" }}>
                              <div>
                                <i className="fas fa-lightbulb me-2" style={{ color: "#ff1493" }}></i>
                                <strong style={{ color: "#ff1493" }}>WHAT'S NEXT?</strong>{" "}
                                <span>{localStatus === 1 ? "Mark this PO as Issued to proceed." : "PO has been issued successfully!"}</span>
                              </div>
                            </div>

                            {/* ✅ CHANGE 8: PO Summary table - Display qty with 3 decimals */}
                            <div ref={poSummaryRef} className="position-relative d-flex justify-content-center">
                              <Card className="shadow border-0 position-relative" style={{ width: "100%", maxWidth: "800px", borderRadius: "12px", backgroundColor: "#fff" }}>
                                <div style={{
                                  position: "absolute",
                                  top: "20px",
                                  left: "-30px",
                                  backgroundColor: localStatus === 1 ? "#f8690aff" : "#28a745",
                                  color: "#fff",
                                  transform: "rotate(-45deg)",
                                  width: "150px",
                                  textAlign: "center",
                                  fontWeight: "600",
                                  padding: "5px 0",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                                  fontSize: "12px",
                                }}>
                                  {localStatus === 1 ? "DRAFT" : "ISSUED"}
                                </div>

                                <Card.Body className="p-5">
                                  <div className="text-center mb-5">
                                    <h2 className="fw-bold" style={{ fontSize: "36px" }}>PURCHASE ORDER</h2>
                                    <h3 className="text-dark mb-2">PO# {selectedPo.po_number}</h3>
                                  </div>

                                  <Row className="mb-5">
                                    <Col md={6}>
                                      <p>
                                        <strong>PO Date:</strong>{" "}
                                        {selectedPo.po_date
                                          ? new Date(selectedPo.po_date).toLocaleDateString("en-GB")
                                          : "-"}
                                      </p>
                                      <p><strong>Supplier:</strong> {getSupplierName(selectedPo.supplier_id)}</p>
                                    </Col>
                                    <Col md={6} className="text-end">
                                      <p>
                                        <strong>Expected Delivery Date:</strong>{" "}
                                        {selectedPo.expected_delivery_date
                                          ? new Date(selectedPo.expected_delivery_date).toLocaleDateString("en-GB")
                                          : "-"}
                                      </p>
                                    </Col>
                                  </Row>

                                  <div className="table-responsive mb-5">
                                    <table className="table table-bordered">
                                      <thead style={{ backgroundColor: "#b1d4f7f5", color: "#fff" }}>
                                        <tr>
                                          <th>#</th>
                                          <th>Product</th>
                                          <th className="text-end">Qty (kg)</th>
                                          <th className="text-end">Unit Price</th>
                                          <th className="text-end">Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {poData.map((item, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{getProductName(item.product_id)}</td>
                                            <td className="text-end">{parseFloat(item.qty).toFixed(3)} kg</td>
                                            <td className="text-end">₹{parseFloat(item.unit_price).toFixed(2)}</td>
                                            <td className="text-end">₹{(parseFloat(item.qty) * parseFloat(item.unit_price)).toFixed(2)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>

                                  <Row className="justify-content-end mb-5">
                                    <Col md={6}>
                                      <table className="table table-sm">
                                        <tbody>
                                          <tr>
                                            <td className="text-end border-0"><strong>Subtotal</strong></td>
                                            <td className="text-end border-0">₹{parseFloat(selectedPo.sub_total || selectedPo.total_amount).toFixed(2)}</td>
                                          </tr>
                                          <tr>
                                            <td className="text-end border-0"><strong>Discount</strong></td>
                                            <td className="text-end border-0">-₹{parseFloat(selectedPo.discount || 0).toFixed(2)}</td>
                                          </tr>
                                          <tr>
                                            <td className="text-end border-0 pt-3"><h5 className="mb-0"><strong>Total</strong></h5></td>
                                            <td className="text-end border-0 pt-3"><h5 className="mb-0"><strong>₹{parseFloat(selectedPo.total_amount).toFixed(2)}</strong></h5></td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              )}

              {/* ✅ CHANGE 9: Payment Card table - Display qty with 3 decimals */}
              {showPaymentCard && selectedRow && (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh", padding: "20px", background: "#f1f3f6" }}>
                  <Card className="shadow-lg border-0" style={{ width: "100%", maxWidth: "900px", borderRadius: "16px", overflow: "hidden", backgroundColor: "#fff" }}>
                    <div style={{
                      position: "absolute",
                      top: "20px",
                      left: "-30px",
                      backgroundColor: selectedRow.payment_status === 2 ? "#28a745" :
                                       selectedRow.payment_status === 3 ? "#ffc107" : "#dc3545",
                      color: "#fff",
                      transform: "rotate(-45deg)",
                      width: "150px",
                      textAlign: "center",
                      fontWeight: "600",
                      padding: "5px 0",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                      fontSize: "12px",
                    }}>
                      {getPaymentStatusLabel(selectedRow.payment_status).toUpperCase()}
                    </div>

                    <Card.Body className="p-5">
                      <div className="text-center mb-4">
                        <h2 className="fw-bold" style={{ fontSize: "32px", color: "#007bff" }}>PO PAYMENT DETAILS</h2>
                        <p className="text-muted mb-0">PO# {selectedRow.po_number}</p>
                      </div>

                      <Row className="mb-4">
                        <Col md={6}>
                          <p><strong>PO Number:</strong> {selectedRow.po_number}</p>
                          <p><strong>PO Date:</strong> 
                            {selectedRow.po_date
                              ? (() => {
                                  const d = new Date(selectedRow.po_date);
                                  const day = String(d.getDate()).padStart(2, "0");
                                  const month = String(d.getMonth() + 1).padStart(2, "0");
                                  const year = d.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()
                              : "-"}
                          </p>
                        </Col>
                        <Col md={6} className="text-end">
                          <p>
                            <strong>Payment Status:</strong>{" "}
                            <span
                              className={`badge px-3 py-2 rounded-pill fs-6 shadow-sm ${
                                selectedRow.payment_status === 2
                                  ? "bg-success"
                                  : selectedRow.payment_status === 3
                                  ? "bg-warning text-dark"
                                  : "bg-danger"
                              }`}
                            >
                              {getPaymentStatusLabel(selectedRow.payment_status)}
                            </span>
                          </p>
                        </Col>
                      </Row>

                      <div className="table-responsive mb-4">
                        <table className="table table-bordered">
                          <thead style={{ backgroundColor: "#343a40", color: "#fff" }}>
                            <tr>
                              <th>#</th>
                              <th>Product</th>
                              <th className="text-end">Qty (kg)</th>
                              <th className="text-end">Unit Price</th>
                              <th className="text-end">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {poData.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{getProductName(item.product_id)}</td>
                                <td className="text-end">{parseFloat(item.qty).toFixed(3)} kg</td>
                                <td className="text-end">₹{parseFloat(item.unit_price).toFixed(2)}</td>
                                <td className="text-end">₹{(parseFloat(item.qty) * parseFloat(item.unit_price)).toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-end gap-3 mt-3">
                        {selectedRow.payment_status !== 2 ? (
                          <Button className="btn btn-primary px-4 py-2 shadow-sm" onClick={handleConvertToPay}>
                            Convert to Pay
                          </Button>
                        ) : (
                          <Button className="btn btn-success px-4 py-2 shadow-sm" disabled>
                            Payment Completed
                          </Button>
                        )}
                        <Button 
                          variant="outline-secondary" 
                          size="sm" 
                          onClick={() => window.location.reload()}
                        >
                          <i className="fas fa-arrow-left me-2"></i>Back
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              )}

              {showMailCard && selectedPo && (
                <Card className="shadow-lg p-4 mt-4">
                  <h4 className="mb-4 fw-bold">Send Purchase Order Mail</h4>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>From</Form.Label>
                      <Form.Control
                        type="email"
                        value={localStorage.getItem("warehouse_email") || ""}
                        readOnly
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter recipient email"
                        value={toEmail}
                        onChange={(e) => setToEmail(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>CC</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter CC email (optional)"
                        value={ccEmail}
                        onChange={(e) => setCcEmail(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Subject</Form.Label>
                      <Form.Control
                        type="text"
                        value={subject || `Purchase Order – ${selectedPo.po_number || ""}`}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>Body</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={10}
                        value={
                          body ||
                          `Dear ${getSupplierName(selectedPo.supplier_id)},\n\nPlease find details for Purchase Order ${selectedPo.po_number}:\n` +
                            poData
                              .map(
                                (item, idx) =>
                                  `${idx + 1}. ${getProductName(item.product_id)} - Qty: ${parseFloat(item.qty).toFixed(3)} kg, Unit Price: ₹${parseFloat(item.unit_price).toFixed(2)}, Total: ₹${(parseFloat(item.qty) * parseFloat(item.unit_price)).toFixed(2)}`
                              )
                              .join("\n") +
                            `\n\nRegards,\n${createdByName || "Rfpos Team"}`
                        }
                        onChange={(e) => setBody(e.target.value)}
                      />
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2">
                      <Button
                        variant="success"
                        onClick={async () => {
                          if (!toEmail) {
                            toast.error("Recipient email is required!");
                            return;
                          }

                          try {
                            const res = await axios.get(
                              `${var_api}sa_veemart_po_details/getByPoId/${selectedPo.id}`
                            );
                            const items = Array.isArray(res.data) ? res.data : [];
                            setPoData(items);

                            const emailHTML = `
                              <p>Dear ${getSupplierName(selectedPo.supplier_id)},</p>
                              <p>Please find below the details for Purchase Order <b>${selectedPo.po_number}</b>:</p>
                              ${items
                                .map(
                                  (item, idx) =>
                                    `<div>${idx + 1}. ${getProductName(item.product_id)} - Qty: ${parseFloat(item.qty).toFixed(3)} kg, Unit Price: ₹${parseFloat(item.unit_price).toFixed(2)}, Total: ₹${(parseFloat(item.qty) * parseFloat(item.unit_price)).toFixed(2)}</div>`
                                )
                                .join("")}
                              <br/>
                              <p>Regards,<br/>${createdByName || "Veemart Team"}</p>
                            `;

                            await axios.post(`${var_api}sa_veemart_admin/send-email`, {
                              from: localStorage.getItem("warehouse_email"),
                              to: toEmail,
                              cc: ccEmail,
                              subject: subject || `Purchase Order – ${selectedPo.po_number}`,
                              html: emailHTML,
                            });

                            toast.success("Email sent successfully!");
                          } catch (err) {
                            console.error(err);
                            toast.error("Failed to send email");
                          }
                        }}
                      >
                        Send Email
                      </Button>
                      <Button 
                        variant="outline-secondary" 
                        size="sm" 
                        onClick={() => window.location.reload()}
                      >
                        <i className="fas fa-arrow-left me-2"></i>Back
                      </Button>
                    </div>
                  </Form>
                </Card>
              )}

              {/* ✅ CHANGE 10: Add/Edit Form with decimal qty input */}
              {showModal && !showPoSummary && (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-bold mb-0 text-primary">
                      {isEditMode ? "Edit Purchase Order" : "Add Purchase Order"}
                    </h4>
                  </div>

                  <Card className="p-4 shadow-lg" style={{ borderRadius: "16px" }}>
                    <Form onSubmit={handleSubmit}>
                      <Row className="g-3 mb-4">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">PO Number *</Form.Label>
                            <Form.Control
                              type="text"
                              name="po_number"
                              value={formData.po_number}
                              onChange={handleInputChange}
                              placeholder="Enter PO number"
                              className="shadow-sm rounded"
                            />
                            {errors.po_number && <div className="text-danger small">{errors.po_number}</div>}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">PO Date</Form.Label>
                            <Form.Control
                              type="date"
                              name="po_date"
                              value={formData.po_date}
                              onChange={handleInputChange}
                              className="shadow-sm rounded"
                            />
                            {errors.po_date && (
                              <div className="text-danger small">{errors.po_date}</div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Expected Delivery Date
                            </Form.Label>
                            <Form.Control
                              type="date"
                              name="expected_delivery_date"
                              value={formData.expected_delivery_date}
                              onChange={handleInputChange}
                              className="shadow-sm rounded"
                              min={formData.po_date}
                            />
                            {errors.expected_delivery_date && (
                              <div className="text-danger small">
                                {errors.expected_delivery_date}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Supplier *</Form.Label>
                            <Select
                              name="supplier_id"
                              value={
                                supplierData
                                  .map((sup) => ({ value: sup.id, label: sup.supplier_name }))
                                  .find((opt) => opt.value === formData.supplier_id) || null
                              }
                              options={supplierData.map((sup) => ({
                                value: sup.id,
                                label: sup.supplier_name,
                              }))}
                              onChange={(selected) =>
                                setFormData((prev) => ({ ...prev, supplier_id: selected ? selected.value : "" }))
                              }
                              placeholder="Select Supplier"
                              isClearable
                              isSearchable
                            />
                            {errors.supplier_id && (
                              <div className="text-danger small">{errors.supplier_id}</div>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>

                      <h5 className="fw-bold text-secondary border-bottom pb-2 mb-3">Item Table</h5>
                      <Table bordered hover responsive className="shadow-sm rounded">
                        <thead className="bg-light">
                          <tr>
                            <th>Product </th>
                            <th>Qty (kg)</th>
                            <th>Unit Price</th>
                            <th>Subtotal</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.length === 0 ? (
                            <tr>
                              <td colSpan={5} className="text-center text-muted py-3">
                                No items added yet
                              </td>
                            </tr>
                          ) : (
                            items.map((item, idx) => (
                              <tr key={idx}>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={item.product_name}
                                    onChange={(e) => handleItemChange(idx, "product_name", e.target.value)}
                                    placeholder="Enter product"
                                    className="shadow-sm rounded"
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    min={0}
                                    step="0.001"
                                    value={item.qty_count}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (val === "" || /^\d*\.?\d{0,3}$/.test(val)) {
                                        handleItemChange(idx, "qty_count", val === "" ? 0 : parseFloat(val));
                                      }
                                    }}
                                    className="shadow-sm rounded"
                                    placeholder="0.000 kg"
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    min={0}
                                    step="0.01"
                                    value={item.unit_price}
                                    onChange={(e) =>
                                      handleItemChange(idx, "unit_price", parseFloat(e.target.value) || 0)
                                    }
                                    className="shadow-sm rounded"
                                    placeholder="0.00"
                                  />
                                </td>
                                <td className="fw-semibold">₹{(parseFloat(item.qty_count) * parseFloat(item.unit_price)).toFixed(2)}</td>
                                <td>
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => handleRemoveRow(idx)}
                                    className="rounded-pill px-3"
                                  >
                                    Delete
                                  </Button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </Table>

                      <div className="d-flex gap-3 mb-4">
                        <Button
                          variant="link"
                          className="text-primary fw-semibold p-0"
                          style={{ textDecoration: "none" }}
                          onClick={handleAddRow}
                        >
                          + Add New Row
                        </Button>

                        <Button
                          variant="link"
                          className="text-primary fw-semibold p-0"
                          style={{ textDecoration: "none" }}
                          onClick={() => setShowBulkModal(true)}
                        >
                          + Add Items in Bulk
                        </Button>
                      </div>

                      <h5 className="fw-bold text-secondary border-bottom pb-2 mb-3">Billing Summary</h5>
                      <Card className="p-2 shadow-sm mb-3" style={{ borderRadius: "8px", maxWidth: "300px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-semibold">Sub Total</span>
                          <span className="fw-bold">₹{subTotal.toFixed(2)}</span>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-semibold">Discount</span>
                          <Form.Control
                            type="number"
                            step="0.01"
                            value={discount}
                            onChange={(e) => setDiscount(parseFloat(e.target.value) || 0)}
                            style={{ width: "80px", fontSize: "0.85rem", padding: "2px 6px" }}
                            className="shadow-sm rounded"
                            placeholder="0.00"
                          />
                        </div>

                        <hr className="my-2" />
                        <div className="text-center mt-1">
                          <h6 className="fw-bold">Total: ₹{total.toFixed(2)}</h6>
                        </div>
                      </Card>

                      <div className="d-flex justify-content-end gap-2">
                        <Button
                          variant="secondary"
                          type="submit"
                          disabled={loading}
                          style={{ borderRadius: "6px", minWidth: "120px" }}
                        >
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" />
                              Saving...
                            </>
                          ) : isEditMode ? (
                            "Update"
                          ) : (
                            "Save as Draft"
                          )}
                        </Button>

                        <Button
                          variant="danger"
                          style={{ borderRadius: "6px", minWidth: "120px" }}
                          onClick={() => setShowCancelConfirm(true)}
                          disabled={loading}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Card>
                </>
              )}

              <Modal
                show={showCancelConfirm}
                onHide={() => setShowCancelConfirm(false)}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title className="text-danger fw-bold">
                    <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                    Leave this page?
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <p>If you leave, your unsaved changes will be discarded.</p>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-end">
                  <Button
                    variant="primary"
                    className="px-4"
                    style={{ borderRadius: "6px", backgroundColor: "#007bff", border: "none" }}
                    onClick={() => setShowCancelConfirm(false)}
                  >
                    Stay Here
                  </Button>

                  <Button
                    variant="light"
                    className="px-4 text-dark border"
                    style={{ borderRadius: "6px", backgroundColor: "#e0e0e0" }}
                    onClick={() => {
                      setShowCancelConfirm(false);
                      setShowModal(false);
                    }}
                  >
                    Leave & Discard Changes
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* ✅ CHANGE 11: Bulk Modal with decimal qty */}
              <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} size="xl" centered>
                <Modal.Header closeButton>
                  <Modal.Title>Add Items in Bulk</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md={6} style={{ borderRight: "1px solid #ddd" }}>
                      <Form.Control
                        type="text"
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="mb-3"
                      />
                      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {productData
                          .filter((p) =>
                            p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
                          )
                          .map((p) => (
                            <div
                              key={p.id}
                              className="d-flex justify-content-between align-items-center mb-2"
                            >
                              <span>{p.product_name}</span>
                              <Button
                                variant={selectedProducts[p.id] ? "secondary" : "outline-danger"}
                                size="sm"
                                onClick={() => handleAddToSelected(p)}
                              >
                                {selectedProducts[p.id] ? "✓" : "+"}
                              </Button>
                            </div>
                          ))}
                      </div>
                    </Col>

                    <Col md={6}>
                      <h6>Selected Items (Qty in kg)</h6>
                      {Object.keys(selectedProducts).length === 0 ? (
                        <p className="text-muted">No items selected</p>
                      ) : (
                        Object.values(selectedProducts).map((item) => (
                          <div
                            key={item.product_id}
                            className="d-flex justify-content-between align-items-center mb-2"
                          >
                            <span>{item.product_name}</span>
                            <Form.Control
                              type="number"
                              min={0}
                              step="0.001"
                              value={item.qty_count}
                              onChange={(e) => handleQtyChange(item.product_id, e.target.value)}
                              style={{ width: "100px" }}
                              placeholder="0.000 kg"
                            />
                          </div>
                        ))
                      )}
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-end gap-2">
                  <Button
                    variant="primary"
                    onClick={handleConfirmBulkAdd}
                    style={{ borderRadius: "6px", minWidth: "120px", backgroundColor: "#007bff", border: "none" }}
                  >
                    Add Products
                  </Button>

                  <Button
                    variant="secondary"
                    onClick={() => setShowBulkModal(false)}
                    style={{ borderRadius: "6px", minWidth: "120px", backgroundColor: "#e0e0e0", color: "#000", border: "none" }}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          )}
        </Card.Body>
      </Card>

      <ToastContainer />
    </>
  );
};

export default PurchaseOrderMaster;